import React from 'react';
import CacheBuster from 'react-cache-buster';
import { version } from '../package.json';
import ReactPWAInstallProvider from 'react-pwa-install';
import { SnackbarProvider } from 'material-ui-snackbar-provider';

import { ThemeProvider } from '@material-ui/core/styles';

import AppRouter from './components/AppRouter';
import { AuthContextProvider } from './context/authContext';
import { NavContextProvider } from './context/navContext';
import { ModeContextProvider } from './context/modeTypeContext';
import { SelectedStoreContextProvider } from './context/selectedStoreContext';
import theme from './styles/theme';

function App() {
  return (
    <CacheBuster currentVersion={version} isEnabled={true}>
      <ThemeProvider theme={theme}>
        <AuthContextProvider>
          <NavContextProvider>
            <ModeContextProvider>
              <SelectedStoreContextProvider>
                <ReactPWAInstallProvider>
                  <SnackbarProvider SnackbarProps={{ autoHideDuration: 4000 }}>
                    <AppRouter />
                  </SnackbarProvider>
                </ReactPWAInstallProvider>
              </SelectedStoreContextProvider>
            </ModeContextProvider>
          </NavContextProvider>
        </AuthContextProvider>
      </ThemeProvider>
    </CacheBuster>
  );
}

export default App;
